import { useEffect, useRef, useState } from "react";
import { getUserProfile } from "helpers";
import axios from "axios";

const useHandleCollections = (url) => {
  const collectionsUserRef = useRef({});

  const getDataSavedByUser = async (id, createUser = false) => {
    try {
      const { data } = await axios({
        url: `/api/user-data/${encodeURIComponent(id)}`,
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        timeout: 8000,
        responseType: "json",
        data: {
          createUser,
        },
      });
      const { user } = data;
      collectionsUserRef.current = user?.data?.types ?? {};
      collectionsUserRef.isRecipeCollectionSuggested = user?.data?.isRecipeCollectionSuggested;
    } catch (error) {
      console.error(error);
    }
  };

  const addCollection = async (collectionName, noteSaved, type) => {
    try {
      if (!noteSaved.userId)
        throw new Error("noteSaved.status");
      if (!collectionName) throw new Error("collectionName is required");
      const { data } = await axios({
        url: `/api/user-data/${encodeURIComponent(noteSaved.userId)}`,
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        timeout: 8000,
        responseType: "json",
        data: {
          createUser: true,
          collection: {
            cmd: "add",
            name: collectionName,
            type: type,
          },
        },
      });
      const { user } = data;
      if (!!user) {
        collectionsUserRef.isRecipeCollectionSuggested = false;
        return user?.data?.types ?? {};
      } else {
        throw new Error("No se encontró el usuario");
      }
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {    
    const { id, subscriptionStatus } = getUserProfile() ?? {
      id: null,
      subscriptionStatus: null,
    };
    if (!!id) {
      getDataSavedByUser(id);
    }
  }, []);

  return {
    collectionsUserRef,
    addCollection,
  };
};

export default useHandleCollections;
